import { Injectable } from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { EventService } from "../event-service/event.service";
import { SendDataModalComponent } from "./send-data-modal.component";

@Injectable()
export class SendDataModalService {
  constructor(
    public modalService: NgbModal,
    private eventService: EventService,
  ) {}

  public open() {
    const modalRef = this.modalService.open(SendDataModalComponent, {
      backdropClass: "modal-backdrop__semi-transparent",
      centered: true,
      size: "md",
      windowClass: "modal-content__border",
    });
    this.eventService.publish("show-send-data-btn", false);
    modalRef.dismissed.subscribe((show) => {
      this.eventService.publish("show-send-data-btn", show);
    });
  }
}
